module.exports = __webpack_public_path__ + "static/media/favicon.a63b6e88.ico";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nxbus/favicon.ico
// module id = 771
// module chunks = 0